import * as yup from "yup";

export const validationSchema = yup.object().shape({
  InsuredBirthDate: yup
    .string()
    .required("Обязательное поле")
    .matches(
      /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[012])\.(19[0-9][0-9]|20[0-2][0-9])$/,
      "Неверная дата"
    )
    .test("is-valid-date", "Некорректная дата", (value) => {
      const [day, month, year] = value.split(".").map(Number);
      const date = new Date(year, month - 1, day);
      const minDate = new Date(1915, 0, 1);
      return (
        date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day &&
        date >= minDate
      );
    }),
  LastName: yup.string().required("Обязательное поле"),
  FirstName: yup.string().required("Обязательное поле"),
  MiddleName: yup.string(),
  BirthDate: yup
    .string()
    .required("Обязательное поле")
    .matches(
      /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[012])\.(19[0-9][0-9]|20[0-2][0-9])$/,
      "Неверная дата"
    )
    .test("is-valid-date", "Некорректная дата", (value) => {
      const [day, month, year] = value.split(".").map(Number);
      const date = new Date(year, month - 1, day);
      const minDate = new Date(1915, 0, 1);
      return (
        date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day &&
        date >= minDate
      );
    }),
  Gender: yup.string().required("Обязательное поле"),
  Email: yup
    .string()
    .required("Обязательное поле")
    .email("Некорректный формат почты"),
  Phone: yup.string().required("Обязательное поле"),
  CountryID: yup.string().required("Обязательное поле"),
  DocumentDate: yup
    .string()
    .required("Обязательное поле")
    .matches(
      /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[012])\.(19[0-9][0-9]|20[0-2][0-9])$/,
      "Неверная дата"
    )
    .test("is-valid-date", "Некорректная дата", (value) => {
      if (!value) return false;
      const [day, month, year] = value.split(".").map(Number);
      const date = new Date(year, month - 1, day);
      const minDate = new Date(1915, 0, 1);
      const maxDate = new Date();
      maxDate.setHours(23, 59, 59, 999);
      const isValidDate =
        date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day;

      return isValidDate && date >= minDate && date <= maxDate;
    }),
  DocumentDepartment: yup.string().required("Обязательное поле"),
  DepartmentCode: yup.string().required("Обязательное поле"),
  DocumentNumber: yup.string().required("Обязательное поле"),
  DocumentSeries: yup.string().required("Обязательное поле"),
});

export const validationSchemaInrured = (
  isRussia: boolean,
  policyholderIsSame: boolean
) =>
  yup.object().shape({
    Insurer: yup.object().shape({
      LastName: yup
        .string()
        .required("Обязательное поле")
        .matches(/^[А-Яа-яёЁ -]+$/, "Допустимы только символы кириллицы"),
      FirstName: yup
        .string()
        .required("Обязательное поле")
        .matches(/^[А-Яа-яёЁ -]+$/, "Допустимы только символы кириллицы"),
      MiddleName: yup
        .string()
        .test("cyrillic", "Допустимы только символы кириллицы", (value) => {
          if (!value) return true;
          return /^[А-Яа-яёЁ -]+$/.test(value);
        }),
      BirthDate: yup
        .string()
        .required("Обязательное поле")
        .matches(
          /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[012])\.(19[0-9][0-9]|20[0-2][0-9])$/,
          "Неверная дата"
        )
        .test("is-valid-date", "Некорректная дата", (value) => {
          const [day, month, year] = value.split(".").map(Number);
          const date = new Date(year, month - 1, day);
          const minDate = new Date(1915, 0, 1);
          return (
            date.getFullYear() === year &&
            date.getMonth() === month - 1 &&
            date.getDate() === day &&
            date >= minDate
          );
        })
        .test(
          "is-age-in-range",
          "Возраст должен быть от 18 до " +
            (policyholderIsSame ? "80" : "100") +
            " лет",
          (value) => {
            if (!value) return false;
            const [day, month, year] = value.split(".").map(Number);
            const birthDate = new Date(year, month - 1, day);
            if (isNaN(birthDate.getTime())) return false;
            const today = new Date();
            let age = today.getFullYear() - birthDate.getFullYear();
            const monthDiff = today.getMonth() - birthDate.getMonth();
            if (
              monthDiff < 0 ||
              (monthDiff === 0 && today.getDate() < birthDate.getDate())
            ) {
              age--;
            }
            const minAge = 18;
            const maxAge = policyholderIsSame ? 80 : 100;
            return age >= minAge && age <= maxAge;
          }
        ),
      Gender: yup.string().required("Обязательное поле"),
      Email: yup
        .string()
        .required("Обязательное поле")
        .email("Некорректный формат почты"),
      Phone: yup
        .string()
        .length(11, "Некорректный номер телефона")
        .required("Обязательное поле"),
      CountryID: yup.string().required("Обязательное поле"),
      DocumentSeries: yup.string().when("CountryID", {
        is: () => !isRussia,
        then: (schema) => schema.required("Обязательное поле"),
        otherwise: (schema) => schema.notRequired(),
      }),
      DocumentNumber: yup.string().when("CountryID", {
        is: () => !isRussia,
        then: (schema) => schema.required("Обязательное поле"),
        otherwise: (schema) => schema.notRequired(),
      }),
      DocumentDate: yup.string().when("CountryID", {
        is: () => !isRussia,
        then: (schema) =>
          schema
            .required("Обязательное поле")
            .matches(
              /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[012])\.(19[0-9][0-9]|20[0-2][0-9])$/,
              "Неверная дата"
            )
            .test("is-valid-date", "Некорректная дата", (value) => {
              if (!value) return false;
              const [day, month, year] = value.split(".").map(Number);
              const date = new Date(year, month - 1, day);
              const minDate = new Date(1915, 0, 1);
              const maxDate = new Date();
              maxDate.setHours(23, 59, 59, 999);
              const isValidDate =
                date.getFullYear() === year &&
                date.getMonth() === month - 1 &&
                date.getDate() === day;

              return isValidDate && date >= minDate && date <= maxDate;
            }),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
  });

export const validationSchemaInrureds = (isRussia: boolean) =>
  yup.object().shape({
    Insureds: yup.array().of(
      yup.object().shape({
        LastName: yup
          .string()
          .required("Обязательное поле")
          .matches(/^[А-Яа-яёЁ -]+$/, "Допустимы только символы кириллицы"),
        FirstName: yup
          .string()
          .required("Обязательное поле")
          .matches(/^[А-Яа-яёЁ -]+$/, "Допустимы только символы кириллицы"),
        MiddleName: yup
          .string()
          .test("cyrillic", "Допустимы только символы кириллицы", (value) => {
            if (!value) return true;
            return /^[А-Яа-яёЁ -]+$/.test(value);
          }),
        Phone: yup
          .string()
          .length(11, "Некорректный номер телефона")
          .required("Обязательное поле"),
        BirthDate: yup
          .string()
          .required("Обязательное поле")
          .matches(
            /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[012])\.(19[0-9][0-9]|20[0-2][0-9])$/,
            "Неверная дата"
          )
          .test("is-valid-date", "Некорректная дата", (value) => {
            const [day, month, year] = value.split(".").map(Number);
            const date = new Date(year, month - 1, day);
            const minDate = new Date(1915, 0, 1);
            return (
              date.getFullYear() === year &&
              date.getMonth() === month - 1 &&
              date.getDate() === day &&
              date >= minDate
            );
          })
          .test(
            "is-age-in-range",
            "Возраст должен быть от 18 до 80 лет",
            (value) => {
              if (!value) return false;
              const [day, month, year] = value.split(".").map(Number);
              const birthDate = new Date(year, month - 1, day);
              if (isNaN(birthDate.getTime())) return false;
              const today = new Date();
              const maxBirthDate = new Date(today);
              maxBirthDate.setFullYear(maxBirthDate.getFullYear() - 80);
              const minBirthDate = new Date(today);
              minBirthDate.setFullYear(minBirthDate.getFullYear() - 18);
              return (
                birthDate.getTime() >= maxBirthDate.getTime() &&
                birthDate.getTime() <= minBirthDate.getTime()
              );
            }
          ),
        Gender: yup.string().required("Обязательное поле"),
        CountryID: yup.string().required("Обязательное поле"),
        DocumentSeries: yup.string().when("CountryID", {
          is: () => !isRussia,
          then: (schema) => schema.required("Обязательное поле"),
          otherwise: (schema) => schema.notRequired(),
        }),
        DocumentNumber: yup.string().when("CountryID", {
          is: () => !isRussia,
          then: (schema) => schema.required("Обязательное поле"),
          otherwise: (schema) => schema.notRequired(),
        }),
        DocumentDate: yup.string().when("CountryID", {
          is: () => !isRussia,
          then: (schema) =>
            schema
              .required("Обязательное поле")
              .matches(
                /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[012])\.(19[0-9][0-9]|20[0-2][0-9])$/,
                "Неверная дата"
              )
              .test("is-valid-date", "Некорректная дата", (value) => {
                if (!value) return false;
                const [day, month, year] = value.split(".").map(Number);
                const date = new Date(year, month - 1, day);
                const minDate = new Date(1915, 0, 1);
                const maxDate = new Date();
                maxDate.setHours(23, 59, 59, 999);
                const isValidDate =
                  date.getFullYear() === year &&
                  date.getMonth() === month - 1 &&
                  date.getDate() === day;

                return isValidDate && date >= minDate && date <= maxDate;
              }),
          otherwise: (schema) => schema.notRequired(),
        }),
      })
    ),
  });

export const validationSchemaAgree = yup.object().shape({
  KidAgree: yup.boolean().oneOf([true], "Требуется согласие"),
  PolicyAgree: yup.boolean().oneOf([true], "Требуется согласие"),
  InsuranceRulesAgree: yup.boolean().oneOf([true], "Требуется согласие"),
  AcceptanceAgree: yup.boolean().oneOf([true], "Требуется согласие"),
});
